module.exports = flarum.core.compat['common/helpers/icon'];